import React from 'react';
import WorkNodeBase from '../common/workNodeBase';
import WorkspacesSurface from '../surfaces/workspaces/workspacesSurface';
import { WORKSPACES_ALIAS } from '../domain/schema';

/**
 * WorkspacesNode — the Workspaces widget (`system.work.workspaces`).
 *
 * Thin: builds a SystemOfWorkClient (via WorkNodeBase) and renders the
 * self-loading WorkspacesSurface — the workspace template library editor.
 *
 * The surface fetches its templates on mount. Keying it on the session object's
 * remount key (see WorkNodeBase.surfaceKey) re-runs that fetch when the session
 * is switched/selected and once when the `workspaces` value first loads, so an
 * always-mounted widget reflects live session data without remounting on every
 * unrelated update.
 */
class WorkspacesNode extends WorkNodeBase {
  getClassName() {
    return 'playground-work-node playground-workspaces-node';
  }

  renderBody() {
    return (
      <div className="mission-control-shell">
        <div className="mission-control-surface-body">
          <WorkspacesSurface key={this.surfaceKey(WORKSPACES_ALIAS)} client={this.getClient()} />
        </div>
      </div>
    );
  }
}

export default WorkspacesNode;
